export class GlobalOverlayOptions {
    public constructor(isOverlayVisible: boolean, text: string | null = null) {
        this.IsOverlayVisible = isOverlayVisible;
        this.Text = text;
    }

    public IsOverlayVisible = false;
    public Text: string | null;
}
